import { render, staticRenderFns } from "./salary_other.vue?vue&type=template&id=1c69114f"
import script from "./salary_other.vue?vue&type=script&lang=js"
export * from "./salary_other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports